/* eslint-disable @typescript-eslint/naming-convention */
import { is } from '@common/is/is'

let cache: string | null | undefined

/** GPU info elkérése. */
export default function getGPUInfo (): null | string {
  // Ha már eltároltuk a „GPU információt”.
  if (is.string(cache) || is.null(cache)) {
    return cache
  }

  try {
    const canvas = document.createElement('canvas')
    const gl     = canvas.getContext('webgl') ?? canvas.getContext('experimental-webgl')

    if (!gl) {
      cache = null

      return cache
    }

      // eslint-disable-next-line @typescript-eslint/unbound-method
    if (is.property(gl, 'getExtension') && is.function(gl?.getExtension)) {
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')

      if (!is.property(gl, 'getParameter')) {
        cache = null

        return cache
      }

      if (!debugInfo) {
        const cpuString: string = gl.getParameter(gl.RENDERER) ?? ''

        cache = cpuString

        return cache
      }

      const cpuString: string = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) ?? ''

      cache = cpuString

      return cache
    }

    cache = null

    return cache
  }
  catch {
    cache = null

    return cache
  }
}
